import React, { FunctionComponent } from "react";
import { Box, Text, Icon } from "@familyzone/component-library";

interface ListedFeatureProps {
	icon: string;
	title: string;
	description: string;
}

export const ListedFeature: FunctionComponent<ListedFeatureProps> = ({ icon, title, description }) => {
	return (
		<Box display="flex" alignItems="center" mb={20}>
			<Box borderRadius="md" bg="accent.turquoise.100" mr={20}>
				<Icon icon={icon} variant="solid" color="text.link.default" m={15} boxSize={5} />
			</Box>
			<Box>
				<Text fontSize="lg" fontWeight={500}>
					{title}
				</Text>
				<Text color="neutral.300">{description}</Text>
			</Box>
		</Box>
	);
};
